import * as React from "react"
import { useTranslation } from "react-i18next"

interface SelectedWorkspaceProps {
    workspaceName?: string
    address?: string
}

export const SelectedWorkspace: React.FC<SelectedWorkspaceProps> = ({ workspaceName, address }) => {
    const { t } = useTranslation()
    return (
        <div className="border rounded-2xl p-4 flex flex-row gap-4 border-zinc-200 dark:border-zinc-500">
            <div className="rounded-full bg-[linear-gradient(270deg,var(--violet-300,rgba(196,181,253,0.12))_0%,var(--pink-500,rgba(236,72,153,0.12))_100%)] hidden min-[300px]:block flex-shrink-0">
                <img
                    src="assets/location-pin-solid.png"
                    alt="Location Pin"
                    className="h-12 p-2 w-auto object-contain"
                />
            </div>
            <div className="flex flex-col justify-center min-w-0 flex-1">
                <p className="leading-[24px] text-[16px] truncate">
                    {workspaceName || "No workspace selected"}
                </p>
                <p className="leading-[20px] text-zinc-500 truncate">
                    {address || t('selectedWorkspace.noAddress')}
                </p>
            </div>
        </div>
    )
}